__turbopack_context__.v({
  "onboarding": "PhoneOnboarding-module-scss-module__9PBQza__onboarding",
});
